// @ts-nocheck
import React, {useEffect, useState} from 'react'
import AffiliateShell from './components/AffiliateShell'
import {AFF, card} from './components/affiliateTheme'
import {getAffiliateDashboard} from './core/_requests'

const STATUS_LABEL = {
  finalized: {label: 'מאושר לתשלום', cls: 'badge-light-primary'},
  approved: {label: 'אושר', cls: 'badge-light-info'},
  paid: {label: 'שולם', cls: 'badge-light-success'},
}

const AffiliatePayoutsWrapper = () => {
  const [dash, setDash] = useState<any>(null)

  useEffect(() => {
    getAffiliateDashboard().then((r) => setDash(r.data)).catch(() => {})
  }, [])

  const payouts = dash?.payouts || []
  const lifetimePaid = payouts
    .filter((p) => p.statuses?.includes('paid'))
    .reduce((s, p) => s + (p.total || 0), 0)
  const pending = payouts
    .filter((p) => !p.statuses?.includes('paid'))
    .reduce((s, p) => s + (p.total || 0), 0)

  const SummaryCard = ({label, value, color}) => (
    <div className='col-md-4'>
      <div style={{...card, padding: 24}}>
        <div style={{color: AFF.muted, fontWeight: 600, fontSize: 13.5}}>{label}</div>
        <div style={{fontSize: 28, fontWeight: 700, color, marginTop: 6}}>₪{(value || 0).toLocaleString()}</div>
      </div>
    </div>
  )

  return (
    <AffiliateShell title='תשלומים ועמלות' subtitle='מעקב אחר העמלות שצברת לפי חודש.'>
      <div className='row g-4 mb-4'>
        <SummaryCard label='צפוי החודש' value={dash?.projected_earnings} color={AFF.accent} />
        <SummaryCard label='ממתין לתשלום' value={pending} color={AFF.warning} />
        <SummaryCard label='שולם עד היום' value={lifetimePaid} color={AFF.success} />
      </div>

      <div style={{...card, padding: 0}}>
        <div style={{padding: '18px 24px', borderBottom: `1px solid ${AFF.border}`, fontWeight: 700, color: AFF.ink}}>
          היסטוריית תשלומים לפי חודש
        </div>
        {payouts.length === 0 ? (
          <div style={{textAlign: 'center', padding: 60, color: AFF.muted}}>
            <i className='bi bi-cash-coin' style={{fontSize: 40, opacity: 0.4, display: 'block', marginBottom: 10}} />
            אין עדיין תשלומים שהוקפאו. עמלות מוקפאות בתחילת כל חודש.
          </div>
        ) : (
          <div className='table-responsive'>
            <table className='table align-middle gy-4 mb-0'>
              <thead>
                <tr style={{color: AFF.muted, fontSize: 12, fontWeight: 700, textTransform: 'uppercase'}}>
                  <th style={{paddingInlineStart: 24}}>חודש</th>
                  <th>לקוחות משלמים</th>
                  <th>סטטוס</th>
                  <th className='text-end' style={{paddingInlineEnd: 24}}>סכום</th>
                </tr>
              </thead>
              <tbody>
                {payouts.map((p) => {
                  const primary = p.statuses?.includes('paid')
                    ? 'paid'
                    : p.statuses?.includes('approved')
                    ? 'approved'
                    : 'finalized'
                  const s = STATUS_LABEL[primary] || STATUS_LABEL.finalized
                  return (
                    <tr key={p._id}>
                      <td style={{paddingInlineStart: 24, fontWeight: 600, color: AFF.ink}}>{p._id}</td>
                      <td style={{color: AFF.ink}}>{p.count}</td>
                      <td><span className={`badge ${s.cls}`}>{s.label}</span></td>
                      <td className='text-end' style={{paddingInlineEnd: 24, fontWeight: 700, color: AFF.ink}}>
                        ₪{(p.total || 0).toLocaleString()}
                      </td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </AffiliateShell>
  )
}

export default AffiliatePayoutsWrapper
